/**
 * GTCH-853. Reads the market-restriction refusal off an API error.
 *
 * The API answers 403 with { data: { reason } } when a want-listing cannot be
 * created or re-activated because its market is served by the Buyer Listing
 * Service. Everything else is an ordinary failure and should keep its existing
 * handling.
 *
 * Returns 'MARKET_RESTRICTED' | 'POLICY_LOCKED' | null.
 */
export const MARKET_RESTRICTED = "MARKET_RESTRICTED";
export const POLICY_LOCKED = "POLICY_LOCKED";

const REASONS = [MARKET_RESTRICTED, POLICY_LOCKED];

export const getMarketRestrictedReason = (error) => {
  // Thrown axios error, or a resolved payload passed straight through.
  const reason =
    error?.response?.data?.data?.reason ??
    error?.data?.reason ??
    error?.reason ??
    null;

  return REASONS.includes(reason) ? reason : null;
};

/**
 * Is this want-listing in a market that has moved to the BLS? Set by the API
 * on want-listing detail and list rows; absent while the gate is off.
 */
export const isMarketRestrictedWantAd = (wantAd) =>
  Boolean(wantAd?.isMarketRestricted ?? wantAd?.IsMarketRestricted);
